import { NodeSpec } from 'prosemirror-model';

export const NODE_NAME = 'math_inline';

export const getSchema = (): NodeSpec => {
  return {
    group: 'inline math',
    content: 'text*', // important!
    inline: true, // important!
    atom: true, // important!
    toDOM: () => ['math-inline', { class: 'math-node' }, 0],
    parseDOM: [
      {
        tag: 'math-inline', // important!
      },
    ],
  };
};
